
// components/ItemTotal.jsx
import React from 'react';
import { discountUtils } from '../utils/discountUtils';
import { useLanguage } from '../../../../context/LanguageContext';
import "../OrderItemList.css";

const ItemTotal = ({
    item,
    currencyFormatter,
    showDiscountInfo,
    showQuantityControls,
    showQuantity = true
}) => {
    const { language } = useLanguage();
    const hasDiscount = discountUtils.hasDiscount(item);
    const savings = discountUtils.calculateSavings(item);

    // Translation for quantity text
    const getQuantityText = () => {
        switch (language) {
            case 'ar':
                return 'الكمية:';
            case 'en':
            default:
                return 'Qty:';
        }
    };

    return (
        <div className="item-info-right">
            {/* Quantity display - show when requested and not using quantity controls */}
            {showQuantity && !showQuantityControls && item.quantity && (
                <div className="quantity-display">
                    {getQuantityText()} {item.quantity}
                </div>
            )}

            <span className="total-amount">
                {currencyFormatter((item.price || 0) * (showQuantityControls ? 1 : (item.quantity || 1)))}
            </span>
        </div>
    );
};

export default ItemTotal;